<template>
    <article>
        <p>
            These inspections allow you to monitor the <var>Availability</var> and <var>Latency</var> SLOs (Service Level Objectives) for every application.
            By default, Coroot tracks the <router-link :to="{name: 'docs', params: {chapter: 'metric-exporters', group: 'node-agent', item: 'metrics'}, hash: '#l7'}">application layer metrics</router-link> gathered by <var>coroot-node-gent</var>,
            but you can replace them with your custom Prometheus metrics.
        </p>

        <v-card>
            <v-img eager src="/static/img/docs/coroot-ce/inspections/slo.png" />
        </v-card>

        <h2>Availability</h2>

        <p>
            The predefined <var>Availability</var> SLO: 99% of requests should be server without errors.
            You can easily adjust the objective:
        </p>

        <v-card max-width="600">
            <v-img eager src="/static/img/docs/coroot-ce/inspections/slo-availability.png" />
        </v-card>

        <p>...or configure Coroot to rack your custom Prometheus metrics:</p>

        <v-card max-width="600">
            <v-img eager src="/static/img/docs/coroot-ce/inspections/slo-availability-custom.png" />
        </v-card>

        <h2>Latency</h2>

        <p>
            The predefined <var>Latency</var> SLO: 99% of requests should be served in less that 500ms.
        </p>

        <v-card max-width="600">
            <v-img eager src="/static/img/docs/coroot-ce/inspections/slo-latency.png" />
        </v-card>

        <p>
            You can also define any Prometheus <a href="https://prometheus.io/docs/practices/histograms/" target="_blank">histogram</a> to be used instead of the built-in metrics:
        </p>

        <v-card max-width="600">
            <v-img eager src="/static/img/docs/coroot-ce/inspections/slo-latency-custom.png" />
        </v-card>

    </article>
</template>

<script>

export default {
}
</script>

<style scoped>
</style>
